export default __webpack_public_path__ + "static/media/office2-afterB-1024w.7f0d0d5f.avif";